import { useLanguage } from "@/i18n/LanguageContext";

export function Marquee() {
  const { t } = useLanguage();
  const text = t("marquee");
  return (
    <div data-testid="editorial-marquee" className="relative border-y hairline bg-[#0B0A08] py-6 overflow-hidden">
      <div className="marquee-track">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif-d italic text-2xl md:text-3xl text-[#C5A059]/80 whitespace-nowrap pr-2">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
